"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCartFormSchema = void 0;
var zod_1 = require("zod");
var guards_1 = require("../utils/guards");
var UNSELECTED_VAL = '__unselected';
/**
 * カートフォームのスキーマを生成する
 * @param { CartFormNameList } formNameList カートフォームの名前リスト
 * @returns カートフォームのスキーマ
 */
var createCartFormSchema = function (formNameList) {
    var _a, _b, _c;
    return !formNameList.sizeSelectName
        ? zod_1.z
            .object((_a = {},
            _a[formNameList.quantityInputName] = zod_1.z.coerce.number().int().min(1, '※ 数量は1以上でなければなりません。'),
            _a))
            .brand('cart-schema')
        : (0, guards_1.hasLanguageSelectName)(formNameList)
            ? zod_1.z
                .object((_b = {},
                _b[formNameList.sizeSelectName] = zod_1.z
                    .string()
                    .min(1, '※ サイズを入力して下さい。')
                    .refine(function (val) { return val !== UNSELECTED_VAL; }, '※ サイズを入力して下さい。'),
                _b[formNameList.languageSelectName] = zod_1.z.preprocess(function (val) { return (val ? val : ''); }, zod_1.z.string().min(1, '※ 言語を入力して下さい。')),
                _b[formNameList.quantityInputName] = zod_1.z.coerce.number().int().min(1, '※ 数量は1以上でなければなりません。'),
                _b))
                .brand('cart-schema')
            : zod_1.z
                .object((_c = {},
                _c[formNameList.sizeSelectName] = zod_1.z
                    .string()
                    .min(1, '※ サイズを入力して下さい。')
                    .refine(function (val) { return val !== UNSELECTED_VAL; }, '※ サイズを入力して下さい。'),
                _c[formNameList.quantityInputName] = zod_1.z.coerce.number().int().min(1, '※ 数量は1以上でなければなりません。'),
                _c))
                .brand('cart-schema');
};
exports.createCartFormSchema = createCartFormSchema;
